import React, { useEffect, useState } from "react";

import FourthImg from "../../assets/images/investment-8.jpg";
import MessageData from "./MessageData";
import { getCacheData, postData } from "../../utils/request";
import "./Message.css";

const MSG_URL = "/api/messages/get_message";

const Message = ({ useCache }) => {
    const [message, setMessage] = useState([]);

    const getMessage = async () => {
        setMessage([]);

        if (useCache) {
            const cachedMessage = getCacheData(MSG_URL);
            if (cachedMessage) {
                setMessage(cachedMessage);
            }
        }
        const newMessage = await postData(MSG_URL, useCache, {
            group: "NTHC Commodities Ltd",
        });
        setMessage(newMessage);
    };
    console.log(message);
    useEffect(() => {
        getMessage();
    }, []);

    return (
        <div className="content">
            <MessageData
                className={"first-message"}
                text={message.message}
                image={message.image}
                name={message.manager_name}
                title={message.title}
                key={message.id}
            />

            {/* <MessageData
        className={"message-reverse"}
        heading="Our History"
        text="We have evolved to be more responsive to the needs of our varied clientele and the larger group of stakeholders. Our foremost preoccupation is investment banking but, we also have an appetite to explore other value creating opportunities within the business landscape. We endeavour to create strategic business units through which we undertake specific business activities within the varied sectors of the economy. These strategic business units are incorporated as subsidiary companies to provide diversity of investment held within a respected framework of governance structure that enhances accountability and resource optimisation."
        image={`images/investments/IT_Driven.webp`}
        image2={FourthImg}
      /> */}
        </div>
    );
};

export default Message;
